// extracted by mini-css-extract-plugin
export default {"grid_cols_custom":"ArtistSeeAll_grid_cols_custom__O7drH"};